require('./angulartics');
module.exports = 'angulartics';



//////////////////
// WEBPACK FOOTER
// ./~/angulartics/src/index.js
// module id = 766
// module chunks = 0